import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, Combobox, Button } from '@origo/origo-ui';
import type { RelationFormValues, SelectOption } from '../../../types';
import styles from './RelationEditDialog.module.css';

export interface RelationEditDialogOptions {
    motpart: SelectOption[];
    type: SelectOption[];
    ikrafttredelsesdato: SelectOption[];
    status: SelectOption[];
}

interface RelationEditDialogProps {
    open: boolean;
    values: RelationFormValues;
    options: RelationEditDialogOptions;
    onChange: (field: keyof RelationFormValues, value: string) => void;
    onClose: () => void;
    onSave: () => void;
    isSaving?: boolean;
}

function toComboValue(value: string): string[] {
    return value ? [value] : [];
}

const RelationEditDialog: React.FC<RelationEditDialogProps> = ({
    open,
    values,
    options,
    onChange,
    onClose,
    onSave,
    isSaving = false,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('relations.dialog.edit')}
            footer={
                <div className={styles.footer}>
                    <Button variant="secondary" onClick={onClose} disabled={isSaving}>
                        {t('common.cancel')}
                    </Button>
                    <Button variant="primary" onClick={onSave} disabled={isSaving}>
                        {t('common.save')}
                    </Button>
                </div>
            }
        >
            <div className={styles.fields}>
                <Combobox
                    label={t('relations.fields.motpart')}
                    placeholder={t('relations.fields.motpartPlaceholder')}
                    value={toComboValue(values.motpartPlanId)}
                    onChange={selected => onChange('motpartPlanId', selected[0] ?? '')}
                    options={options.motpart}
                />
                <Combobox
                    label={t('relations.fields.type')}
                    value={toComboValue(values.type)}
                    onChange={selected => onChange('type', selected[0] ?? '')}
                    options={options.type}
                />
                <Combobox
                    label={t('relations.fields.ikrafttredelsesdato')}
                    value={toComboValue(values.ikrafttredelsesdato)}
                    onChange={selected => onChange('ikrafttredelsesdato', selected[0] ?? '')}
                    options={options.ikrafttredelsesdato}
                />
                <Combobox
                    label={t('relations.fields.status')}
                    value={toComboValue(values.status)}
                    onChange={selected => onChange('status', selected[0] ?? '')}
                    options={options.status}
                />
            </div>
        </Dialog>
    );
};

export default RelationEditDialog;
